export default {
  title: '智能助手',
  welcomeTitle: '你好',
  welcomeDesc:
    '我是 AI 智能助手，可以协助你创建巡检任务、安排路线、分析风险。直接输入你的需求即可。',
  realtimeAlarm: '实时告警',
  alarmDetected: '识别到{label}',
  routeName: '航线名：',
  deviceName: '设备名：',
  chatEmpty: '在下方输入你的问题',
  inputPlaceholder: '请输入您的问题',
  voiceInput: '语音输入',
  voiceInputActive: '语音输入中',
  stopVoiceInput: '终止语音输入',
  send: '发送',
  voiceNoTranscript: '未识别到文字，请重试',
  streamErrorDefault: '后端流式响应异常。',
  requestFailed: '请求失败。',
  taskComplete: '已完成当前任务',
  confirmExecuteTask: '确认执行该任务',
  cancelExecuteTask: '取消执行该任务',
  alarmLabel: {
    smoke: '烟雾',
    fire: '火焰',
    box: '杂乱堆物',
    electric_meter_ocr: '电表读数',
    umbrella: '摊贩',
    vehicle_violation: '车辆违停',
  },
  report: {
    inspectionInfo: '巡检信息:',
    inspectionArea: '巡检区域：{area}',
    taskName: '任务名称：{name}',
    inspectionTime: '巡检时间：{time}',
    inspectionTarget: '巡检目标：{target}',
    defaultArea: '湾区智联园区',
    abnormalSummary: '异常事件汇总:',
    serialNo: '序号',
    type: '类型',
    alarmCount: '告警数量',
    noAlarmData: '暂无告警数据',
    summaryAdvice: '总结与建议:',
    summaryLine: '总结：本次巡检共发现 {count} 起异常事件，其中重点类型为 {type}。',
    adviceWithAlarms:
      '建议：请对高频违停点位进行重点管控，安排现场劝离与复查；建议在高峰时段加强巡查，并对重点区域持续复核。',
    adviceNoAlarms:
      '建议：本次未发现违停告警，建议维持当前巡检策略，并在早晚高峰时段保持常态化巡查。',
    unknownType: '未知类型',
    noSignificantAbnormal: '无显著异常',
  },
}
